<template>
  <div
    class="rounded-lg duration-500 overflow-hidden divide-y transform transition shadow"
  >
    <div class="relative hover:opacity-100 slideUpButton">
      <img
        class="h-96 w-full object-cover"
        :src="baseUrlSrc(data && data.thumbnail_url)"
        alt=""
        @error="defaultImage"
        style="filter: brightness(0.6)"
      />
      <div
        class="flex flex-col top-3/4 justify-center absolute items-center text-white w-full capitalize"
      >
        <div class="content z-10">
          <p
            v-if="data.title.length > 15"
            class="text-xl font-sans max-h-17.5 text-center overflow-hidden tracking-tighter w-full font-bold px-2"
          >
            {{ handleStr(data.title, 30) }}
          </p>
          <p
            v-else
            class="text-2xl font-sans text-center font-semibold tracking-wider w-full px-4"
          >
            {{ data.title }}
          </p>
          <p class="z-10 text-center">{{ data.trainer_name }}</p>
        </div>
        <div class="invisible sliding-buttons mt-2 w-full px-3 z-10">
          <div class="flex flex-col text-center" v-if="data.course_id">
            <router-link
              :to="{
                name: 'UserCourseDetails',
                params: {
                  id: data.course_id,
                },
              }"
              class="bg-white p-3 text-black rounded-lg cursor-pointer font-medium"
            >
              Book this Class Pack
            </router-link>
            <router-link
              :to="{
                name: 'UserCourseDetails',
                params: {
                  id: data.course_id,
                },
              }"
              class="bg-black p-3 mt-2 text-white rounded-lg cursor-pointer font-medium"
            >
              Class Pack Details
            </router-link>
          </div>
          <div class="flex flex-col text-center" v-else>
            <router-link
              :to="{
                name: 'UserSessionDetails',
                params: {
                  id: data.session_id,
                },
              }"
              class="bg-white p-3 text-black rounded-lg cursor-pointer font-medium"
            >
              Book this class
            </router-link>
            <router-link
              :to="{
                name: 'UserSessionDetails',
                params: {
                  id: data.session_id,
                },
              }"
              class="bg-black p-3 mt-2 text-white rounded-lg cursor-pointer font-medium"
            >
              Class Details
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Heart, HeartFill, Star } from "@/components/icons";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "NewSessionCard",
  components: {
    Heart,
    HeartFill,
    Star,
  },
  props: {
    data: {
      type: Object,
    },
    showDateTime: {
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters(["userSessionDetail"]),
  },
  data() {
    return {
      currentPath: "",
      trainerImage: this.data && this.data.trainer_thumbnail_url,
      trainerName: this.data && this.data.trainer_name,
    };
  },
  methods: {
    ...mapActions([
      "postUserSessionAddRemoveFavourite",
      "getUserSessionDetail",
      "getUserTrendingSessions",
    ]),

    async handlePostLike(e, id) {
      e.preventDefault();

      let favourite;
      if (this.data.is_favourite === "yes") favourite = "no";
      else favourite = "yes";

      const data = {
        favourite: favourite,
        entity_id: this.data.session_id || this.data.course_id,
        post_id: id,
        entity_type: this.data.entity_type || 1,
      };
      await this.postUserSessionAddRemoveFavourite(data);
      await this.getUserSessionDetail(data.entity_id);

      if (this.data.course_id) {
        this.data.is_favourite =
          this.data.is_favourite === "yes" ? "no" : "yes";
      } else {
        this.data.is_favourite =
          this.userSessionDetail &&
          this.userSessionDetail.session &&
          this.userSessionDetail.session.details.is_favourite;
        this.data.is_favourite =
          this.data.is_favourite === false ? "no" : "yes";
        this.trainerImage =
          this.userSessionDetail &&
          this.userSessionDetail.trainer &&
          this.userSessionDetail.trainer.details &&
          this.userSessionDetail.trainer.details.thumbnail_url;
        this.trainerName =
          this.userSessionDetail &&
          this.userSessionDetail.trainer &&
          this.userSessionDetail.trainer.details &&
          this.userSessionDetail.trainer.details.name;
      }
    },
  },
  created() {
    this.currentPath = this.$router.currentRoute.path;
  },
};
</script>

<style lang="scss" scoped>
.shadow {
  filter: drop-shadow(0px 24px 34px rgba(0, 0, 0, 0.07));
}
.slideUpButton:hover .sliding-buttons {
  transition: 0.2s all ease-in-out;
  transform: translateY(-90px);
  visibility: visible;
}

.slideUpButton:hover .content {
  transition: 0.2s all ease-in-out;
  transform: translateY(-90px);
}

.slideUpButton img {
  width: 100%;
  transition: 0.2s all ease-in-out;
}

.slideUpButton:hover img {
  transform: scale(1.05);
}
</style>